import React, {ReactNode} from 'react'
import {MdInfoOutline as InfoIcon, MdLoop} from 'react-icons/md'
import classnames from '@helpers/misc/classnames'
import Tooltip from '@packages/justo-parts/lib/components/Tooltip'

import styles from './styles.module.css'

export default function RequiresRoundTrip({
  color,
  children,
  hidden
}: {
  children: ReactNode
  color?: string
  hidden?: boolean
}) {
  if (hidden) return <>{children}</>

  return (
    <div className={classnames('flex items-center', styles.container)}>
      <MdLoop className="mr-1" color={color ? color : 'var(--text)'} />
      {children}
      <Tooltip content="El medio de pago seleccionado requiere viaje de ida y vuelta, por lo que podría estar afectando el valor de despacho.">
        <InfoIcon className="ml-1" color="grey" />
      </Tooltip>
    </div>
  )
}
